import { IoIosArrowForward } from "react-icons/io";

type DropdownArrowProps = {
  isActive: boolean | undefined;
};

const DropdownArrow: React.FC<DropdownArrowProps> = ({ isActive }) => (
  <IoIosArrowForward
    size={19}
    color={"#404149"}
    style={{ transform: isActive ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease-in-out' }}
  />
);


export default DropdownArrow;